<template>
  <div class="root-box">
    <el-table :data="list" :default-expand-all="false" :max-height="tableHeight" :show-header="false" class="no-hover"
      ref="table" stripe>
      <el-table-column type="expand">
        <template slot-scope="props">
          <div class="table-expand">
            <el-table :data="props.row.orderList" :show-header="false" class="no-hover">
              <el-table-column width="50">
                <template slot-scope="scope">
                  <span class="order-index">{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="showTime" width="120"></el-table-column>
              <el-table-column prop="orderSource" width="80">
                <template slot-scope="scope">
                  <div v-order-source="scope.row.orderSource"></div>
                </template>
              </el-table-column>
              <el-table-column prop="number" width="60">
                <template slot-scope="scope">{{ scope.row | orderTypeTransfer }}</template>
              </el-table-column>
              <el-table-column prop="price" width="100">
                <template slot-scope="scope">{{ scope.row.price | moneyFormat }}元</template>
              </el-table-column>
              <el-table-column prop="telephone" width="130">
                <template slot-scope="scope">
                  <tel-cell :order="scope.row" />
                </template>
              </el-table-column>
              <el-table-column prop="departure" label="起点"></el-table-column>
              <el-table-column prop="destination" label="终点"></el-table-column>
              <el-table-column prop="payStatus" width="80">
                <template slot-scope="scope">
                  <span :class="{ red: scope.row.payStatus === 0 }">{{
                    scope.row.payStatus | enumTransfer(payStatusOpts)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column width="100" prop="createTime"></el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="司机编号" width="140">
        <template slot-scope="scope">
          <span class="route-info pointer" @click="toggleRow(scope.row)">{{ scope.row.route.driverNo }}</span>
        </template>
      </el-table-column>

      <el-table-column label="行程信息">
        <template slot-scope="scope">
          <div class="route-info pointer" @click="toggleRow(scope.row)">
            <span>剩余座位数: </span>
            <span class="red">{{ scope.row.route.number - scope.row.route.used }}</span>
            <span>{{ scope.row.route.date }} / {{ scope.row.route.showTime }}</span>
            <span>{{ scope.row.route.pathId | pathNameTransfer }}</span>
            <span v-if="scope.row.route.number !== 3 && !scope.row.route.locked" class="red">{{ scope.row.route.number
            }}座车</span>
            <span class="muted">{{ scope.row.route.locked ? "（已有行程）" : "（模拟）" }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="page">
      <span class="pagination-sum">共{{ list.length }}个行程， {{ totalPerson }}人</span>
    </div>
  </div>
</template>

<script>
import TelCell from "@/components/TelCell";
import { mapState } from "vuex";

export default {
  components: { TelCell },
  props: {
    trips: {
      type: Array,
      default: () => []
    },
    tableHeight: {
      type: Number,
      default: 650
    }
  },
  computed: {
    ...mapState({
      payStatusOpts: (state) => state.enumMap["PAY_STATUS"]
    }),
    list() {
      return (this.trips || []).map((trip) => ({
        route: {
          driverNo: trip.driverNo,
          date: trip.date,
          showTime: trip.showTime,
          number: trip.seats,
          used: trip.assignedSeats,
          pathId: trip.pathId,
          locked: !!trip.locked
        },
        orderList: trip.orderList || []
      }));
    },
    totalPerson() {
      return (this.trips || []).reduce((sum, trip) => sum + (trip.assignedSeats || 0), 0);
    }
  },
  methods: {
    toggleRow(row) {
      this.$refs.table.toggleRowExpansion(row);
    }
  }
};
</script>

<style lang="less" scoped>
.root-box {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.page {
  flex-shrink: 0;
}

.table-expand {
  padding: 0 0 0 48px;
}

.order-index {
  display: inline-block;
  width: 22px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  font-size: 12px;
}

.route-info {
  font-size: 14px;

  span {
    margin-right: 10px;
  }
}

.pointer {
  cursor: pointer;
}

.red {
  color: #f56c6c;
}

.muted {
  color: #909399;
  font-size: 12px;
}

.pagination-sum {
  color: #f56c6c;
  margin-top: 4px;
  font-size: 12px;
  display: inline-block;
}
</style>
